import React, { useMemo } from "react";

import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IFormSchema } from "shared/types";
import { IStage } from "Venues/types";
import { convertDimensions, useUnitType } from "shared/utils";

import { formData, lightFormData } from "./formData";
import { dimensionsFormData } from "./dimensionsFormData";
import { merge } from "lodash-es";

const schema: IFormSchema = {
  ...formData,
  fields: [...formData.fields, ...dimensionsFormData.fields],
  defaultValues: {
    ...formData.defaultValues,
    ...dimensionsFormData.defaultValues,
  },
};

interface StageFormProps {
  apiStatus?: IAPIState;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  submitMode?: "isDirty";
  handleSubmit: (stage: IStage) => void;
  updatePlaceholder?: (stage: IStage) => void;
  isLightForm?: boolean;
}

export const StageForm: React.FC<StageFormProps> = ({
  apiStatus,
  hasError,
  defaultValues,
  buttons,
  children,
  submitMode,
  handleSubmit,
  updatePlaceholder = () => {},
  isLightForm,
}) => {
  const { unitType } = useUnitType();

  const formSchema = useMemo(
    () => merge({}, isLightForm ? lightFormData : schema, { defaultValues }, { buttons }),
    [isLightForm, defaultValues, buttons]
  );

  const onSubmit = (stage: IStage) => {
    const cleanStage = convertDimensions(stage);
    handleSubmit(cleanStage);
  };

  return (
    <FormBuilder
      unitType={unitType}
      {...formSchema}
      onSubmit={onSubmit}
      isSubmitting={apiStatus === IAPIState.pending}
      onBlur={updatePlaceholder}
      submitMode={submitMode}
      apiErrorMessage={hasError}
      dataTestId="stage_form"
    >
      {children}
    </FormBuilder>
  );
};
